/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { IntegrationSection } from './IntegrationSection/IntegrationSection'
import useUser from '../Shared/UserProvider/useUser'
import { isProviderAPos } from '../../services/Provider/Provider.service'
import { BusinessPerformanceSection } from './BusinessPerformanceSection/BusinessPerformanceSection'
import { OperationalPerformanceSection } from './OperationalPerformanceSection/OperationalPerformanceSection'
import { OfferPerformanceSection } from './OfferPerformanceSection/OfferPerformanceSection'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import useBreadcrumb from '../NavBar/useBreadcrumb'
import { FeatureInfo } from '../Shared/FeatureInfo/FeatureInfo'


const Dashboard = () => {
    const [t] = useTranslation()
    const {setPaths} = useBreadcrumb()
    const { user } = useUser()

    useEffect(() => {
        setPaths([{
            text: t('breadcrumb.home'),
            link: false,
            path: '/',
        }])
    }, [setPaths, t])

    return (
      <>
          <FeatureInfo featureName="dashboard"
                       css={css`
                           &.ui.message {
                               margin-bottom: 1rem;
                           }

                           &.blue.info.circle.icon {
                               margin-top: 1rem;
                               width: 16px;
                               height: 16px;
                               vertical-align: text-top;
                           }
                       `}>
              <FeatureInfo.Text>Le tableau de bord vous permet de suivre en temps réel les performances de votre commerce et d'optimiser vos opérations quotidiennes.</FeatureInfo.Text>
              <FeatureInfo.List>
                  <FeatureInfo.ListItem>Visualisez vos indicateurs commerciaux : ventes du jour, chiffre d'affaires mensuel et activité négative</FeatureInfo.ListItem>
                  <FeatureInfo.ListItem>Suivez vos performances opérationnelles : taux de scan, taux de produits trouvés et mode occupé</FeatureInfo.ListItem>
                  <FeatureInfo.ListItem>Analysez la santé de votre catalogue et les produits les plus performants</FeatureInfo.ListItem>
              </FeatureInfo.List>
          </FeatureInfo>

          {isProviderAPos(user.provider) && <IntegrationSection />}

          <BusinessPerformanceSection />

          <OperationalPerformanceSection />

          {!user.isLoggedInOwnScope && <OfferPerformanceSection/>}
      </>
    )
}

export { Dashboard }
